"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notify = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../../assets/css/components/notificacao/Notification.css");

var _logo = require("../../assets/img/logo.svg");

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var notify = exports.notify = function () {
    function notify() {
        _classCallCheck(this, notify);
    }

    _createClass(notify, null, [{
        key: "error",
        value: function error(properties) {
            properties.level = 'error';
            properties.type = 'message';
            properties.titulo = properties.title || 'Error';
            properties.menssagem = properties.message;
            delete properties.title;
            delete properties.message;
            this.notify(properties);
        }
    }, {
        key: "success",
        value: function success(properties) {
            properties.level = 'success';
            properties.type = 'message';
            properties.titulo = properties.title || 'Sucesso';
            properties.menssagem = properties.message;
            delete properties.title;
            delete properties.message;
            this.notify(properties);
        }
    }, {
        key: "info",
        value: function info(properties) {
            properties.level = 'info';
            properties.type = 'message';
            properties.titulo = properties.title || 'Info';
            properties.menssagem = properties.message;
            delete properties.title;
            delete properties.message;
            this.notify(properties);
        }
    }, {
        key: "warning",
        value: function warning(properties) {
            properties.level = 'warning';
            properties.type = 'message';
            properties.titulo = properties.title || 'Alerta';
            properties.menssagem = properties.message;
            delete properties.title;
            delete properties.message;
            this.notify(properties);
        }
    }, {
        key: "notify",
        value: function notify(properties) {
            var _this = this;

            if (!properties.ref.addNotification) {
                throw new DOMException("Para gerar a notificação," + " era esperado a referencia de um componente do tipo NotificationSystem,mas a função de notificação recebeu: " + _typeof(properties.ref) + ".");
            }

            if (properties.type === undefined || properties.type.toLowerCase() === 'notification') {
                properties.children = _react2.default.createElement(
                    "div",
                    { className: "ntf-push", role: "alert", ref: function ref(d) {
                            return _this.div = d;
                        } },
                    _react2.default.createElement(
                        "div",
                        { className: "ntf-icon", "aria-hidden": "true" },
                        _react2.default.createElement("img", { src: properties.icon ? properties.icon : _logo2.default, alt: "icones notifica\xE7\xE3o" })
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "ntf-info" },
                        _react2.default.createElement(
                            "title",
                            { className: "ntf-title" },
                            properties.titulo
                        ),
                        _react2.default.createElement(
                            "small",
                            null,
                            properties.menssagem
                        ),
                        _react2.default.createElement(
                            "span",
                            null,
                            properties.moreInfo
                        )
                    )
                );
                properties.level = 'success';
                properties.ref.addNotification(properties);
            } else {
                properties.children = _react2.default.createElement(
                    "div",
                    { className: "ntf", role: "alert", ref: function ref(d) {
                            return _this.div = d;
                        } },
                    _react2.default.createElement(
                        "title",
                        { className: "notification-title" },
                        properties.titulo
                    ),
                    _react2.default.createElement(
                        "small",
                        null,
                        properties.menssagem
                    )
                );
                properties.ref.addNotification(properties);
            }
        }
    }]);

    return notify;
}();


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/notificacao/Notification.js
// module id = 590
// module chunks = 0